export default __webpack_public_path__ + "static/media/id15_outline.9b250e31.png";